import { apiRequest } from "./axios";

/**
 * Hours Log API functions
 * Functions for managing daily hours log data
 */

// Submit hours log data
export async function submitHoursLog(data) {
  const url = "/hourslog/submit";
  return await apiRequest(url, data, { method: "POST" });
}

// Get hours log data for a specific date
export async function getHoursLogByDate(date) {
  const url = `/hourslog/${date}`;
  return await apiRequest(url, null, { method: "GET" });
}

// Get hours log data for a week
export async function getHoursLogByWeek(weekStart) {
  const url = `/hourslog/week/${weekStart}`;
  return await apiRequest(url, null, { method: "GET" });
}

// Update existing hours log entry
export async function updateHoursLog(id, data) {
  const url = `/hourslog/${id}`;
  return await apiRequest(url, data, { method: "PATCH" });
}

// Delete hours log entry
export async function deleteHoursLog(id) {
  const url = `/hourslog/${id}`;
  return await apiRequest(url, null, { method: "DELETE" });
}
